import { useAppSelector } from '../store'

export function useVenueGroup() {
  return useAppSelector(state => ({ lockedFields: state.clientInfo?.lockedFields }))
}
